import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import { firebaseApp } from './../firebase';

/**
 * Calculate follow-back statistics for a handle
 * Data is automatically updated when UnfollowBot runs
 */
export async function calculateFollowBackStats(userId, handle) {
    if (!userId || !handle) {
        return {};
    }

    try {
        const firestore = getFirestore(firebaseApp);
        
        // Get all botFollows for this handle
        const followsQuery = query(
            collection(firestore, 'botFollows'),
            where('userId', '==', userId),
            where('handle', '==', handle),
            where('status', '==', 'followed')
        );
        
        const followsSnapshot = await getDocs(followsQuery);
        const follows = followsSnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }));
        
        // Group by bot type and calculate stats
        const statsByBotType = {};
        
        follows.forEach(follow => {
            const botType = follow.botType || 'Unknown';
            
            if (!statsByBotType[botType]) {
                statsByBotType[botType] = {
                    totalFollows: 0,
                    followBacks: 0,
                    followBackRate: 0,
                    avgTimeToFollowBack: 0,
                    followBackTimes: []
                };
            }
            
            statsByBotType[botType].totalFollows++;
            
            if (follow.followedBack) {
                statsByBotType[botType].followBacks++;
                
                // Calculate time to follow back if we have both dates
                if (follow.followDate && follow.followBackDate) {
                    const followTime = new Date(follow.followDate).getTime();
                    const followBackTime = new Date(follow.followBackDate).getTime();
                    const timeDiff = (followBackTime - followTime) / (1000 * 60 * 60 * 24); // days
                    statsByBotType[botType].followBackTimes.push(timeDiff);
                }
            }
        });
        
        // Calculate rates and averages
        Object.keys(statsByBotType).forEach(botType => {
            const stats = statsByBotType[botType];
            stats.followBackRate = stats.totalFollows > 0 
                ? (stats.followBacks / stats.totalFollows) * 100 
                : 0;
            
            if (stats.followBackTimes.length > 0) {
                stats.avgTimeToFollowBack = stats.followBackTimes.reduce((a, b) => a + b, 0) / stats.followBackTimes.length;
            }
            
            // Clean up
            delete stats.followBackTimes;
        });
        
        return statsByBotType;
    } catch (error) {
        console.error('Error calculating follow-back stats:', error);
        return {};
    }
}

